import styled from '/web_modules/styled-components.js';
import { motion } from '/web_modules/framer-motion.js';
export const Stack = styled(motion.div).withConfig({
  displayName: "Layout__Stack",
  componentId: "sc-1cao01c-0"
})(["display:flex;flex-direction:column;"]);
export const ResponsiveLayout = styled(motion.div).withConfig({
  displayName: "Layout__ResponsiveLayout",
  componentId: "sc-1cao01c-1"
})(["display:flex;flex-direction:column;@media screen and (min-width:800px){flex-direction:row;}"]);
/* 
  Simulates the `gap`/`row-gap`/`column-gap` css property, 
  since it is not yet supported in Safari. It also behaves weird
  on Chrome @ MacOS with flex-direction: column-reverse, 
  putting the gap at the start only, not between the children
*/

export const gap = (gap, direction) => `
  & > *:not(:last-child) {
    ${direction === 'row' ? `margin-right: ${gap};` : `margin-bottom: ${gap};`}
  }
`;